module.exports = __webpack_public_path__ + "static/media/ObjImage1.f6abb493.png";